import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-about-us-content',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './about-us-content.component.html'
})
export class AboutUsContentComponent {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  onRegisterClick(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/sign-up']);
    }
  }
}
